import { Language } from './translations'

export interface SolutionBenefit {
  id: string
  illustration: string
  title: Record<Language, string>
  text: Record<Language, string>
}

export const solutionBenefits: SolutionBenefit[] = [
  {
    id: 'decisions',
    illustration: 'https://cdn.magicpatterns.com/uploads/fs3RZGXgxsjHMJBdwutiq4/illu_decision.png',
    title: {
      fr: 'Des décisions éclairées, des actions qui comptent.',
      en: 'Informed decisions, actions that matter.'
    },
    text: {
      fr: "Des recommandations personnalisées, adaptées à chaque situation et nourries par l'expérience du terrain.",
      en: 'Personalized recommendations, tailored to every situation and informed by experience in the field.'
    }
  },
  {
    id: 'time',
    illustration: 'https://cdn.magicpatterns.com/uploads/6sLNVzoVyHt2656p9aZGLt/illu_heuresgagnees.png',
    title: {
      fr: 'Moins de temps à analyser. Plus de temps à manager.',
      en: 'Less time analyzing. More time managing.'
    },
    text: {
      fr: 'Les feedbacks sont synthétisés, les priorités identifiées et les prochaines actions clarifiées.',
      en: 'Feedback is synthesized, priorities are identified and next actions are made clear.'
    }
  },
  {
    id: 'teams',
    illustration: 'https://cdn.magicpatterns.com/uploads/ut6J4HVWejEXQGFwjKiSZN/illu_equipe.png',
    title: {
      fr: 'Un meilleur management. Des équipes plus engagées.',
      en: 'Better management. More engaged teams.'
    },
    text: {
      fr: "Une meilleure compréhension des collaborateurs pour renforcer la confiance, la reconnaissance et l'engagement au quotidien.",
      en: 'A better understanding of employees to strengthen trust, recognition and engagement every day.'
    }
  }
]
